module.exports = {"TXTWCL_Today":{"id":"TXTWCL_Today","defaultMessage":"Heute"},"TXTWCL_Tomorrow":{"id":"TXTWCL_Tomorrow","defaultMessage":"Morgen"}}